module.exports = __webpack_public_path__ + "static/media/vodafone-extra-bold.99a6c0a1.woff";